<!-- eslint-disable no-unused-vars -->

<script>
  import { computed, ref } from '@nuxtjs/composition-api'
  import { cartGetters, productGetters } from '@/composables/propeller/getters'
  import { useCart } from '@/composables/propeller/useCart'
  import SingleCartItem from './CartItem/SingleCartItem'
  import { setProductsListTracking } from '~/utils/utils'
  import { gtmSendEvent } from '~/utils/gtm-send-event'
  import { useAttribute, useListAttribute } from '~/composables/useAttribute'
  import { productAttributes } from '~/constants/products.module'

  export default {
    components: {
      SingleCartItem
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    },
    setup (props, { emit }) {
      const { removeItem, updateItemQty } = useCart()

      const loading = ref(false)

      const trackRemoveFromCart = (product, productType, level) => {
        const products = setProductsListTracking([{
          ...product,
          name: productGetters.getName(product),
          productType,
          level,
          quantity: 1
        }])

        delete products[0].index
        gtmSendEvent('remove_from_cart', {
          ecommerce: {
            currency: 'EUR',
            items: products
          },
        }, null, true)
      }

      const remove = async () => {
        loading.value = true
        await removeItem({
          product: props.item
        }).then(() => {
          const { product, priceNet } = props.item
          trackRemoveFromCart({
            ...product,
            price: {
              net: priceNet,
              discount: cartGetters.getItemDiscount(props.item).discount
            },
            id: props.item.itemId,
          }, useAttribute(product, productAttributes.brand), useListAttribute(product, productAttributes.educationType).value.join(', '))
        })

        emit('remove', props.item)
      }

      const update = async (quantity) => {
        loading.value = true

        await updateItemQty({
          product: props.item,
          quantity: parseInt(quantity)
        })
        loading.value = false
      }

      return {
        remove,
        update,
        loading,
        discountInfo: computed(() => cartGetters.getItemDiscount(props.item))
      }
    }
  }
</script>

<template>
  <SingleCartItem
    :item="item"
    :loading="loading"
    :discount-info="discountInfo"
    @remove="remove"
    @update="update"
  />
</template>

<style lang="scss">
.text-link.is-secondary {
  &::after {
    @apply bg-gray-300;
  }
}
</style>
